<template>
	<frontend-layout>
		<Head>
			<title>{{ $t("aboutUs") }} - {{ $t("siteTitle") }}</title>
		</Head>
		<template #header>
			<h1 class="page-title p-0">{{ $t("aboutUs") }}</h1>
		</template>

		<section>
			<div class="ts-space"></div>
			<div class="ts-container">
				<div class="row">
					<div class="ts-tab ts-center-aligned">
						<div class="item is-active" data-tab="cc">
							<span class="ts-icon is-people-group-icon"></span
							>{{ $t("CC") }}
						</div>
						<div class="item" data-tab="developers">
							<span class="ts-icon is-compass-icon"></span
							>{{ $t("about.devTeam") }}
						</div>
						<div class="item" data-tab="thanks">
							<span class="ts-icon is-user-graduate-icon"></span
							>{{ $t("about.specialThanks") }}
						</div>
					</div>
				</div>
				<div class="ts-space"></div>
				<div data-name="cc">
					<h2 class="text-center">組織架構</h2>
					<div class="ts-container">
						<p class="mb-3 paragraph">
							電算中心為校內一級單位，直屬校長督導，另由全校各單位推派代表成立「保護智慧財產權宣導及執行小組」、「資訊系統管理委員會」，
							同時聘請校內教授擔任顧問，協助電算中心共同推動及執行各項資訊業務。
							中心主任之下設有主任室、資源管理組、網路系統組、校務資訊組、技術研發組。
						</p>
						<div class="ts-image is-centered is-large">
							<img
								src="/img/intro.png"
								alt="電算中心組織架構圖" />
						</div>
						<br />
						<div class="ts-center">
							<a
								class="btn btn-primary text-white"
								href="https://www.cc.ncu.edu.tw/"
								target="_blank">
								前往電子計算中心首頁
							</a>
						</div>
					</div>
				</div>
				<div class="ts-grid" data-name="developers">
					<div class="column is-1-wide"></div>
					<template v-for="intro in intros" :key="intro.name">
						<div class="column is-6-wide">
							<div
								class="ts-avater is-circular ts-image is-1-by-1 is-covered card-avater">
								<img :src="intro.avaterUrl" />
							</div>
							<div class="ts-content">
								<div
									class="ts-text is-bold is-big is-center-aligned">
									{{
										$i18n.locale == "zh-TW"
											? intro.name
											: intro.name_en
									}}
									<span
										class="ts-text is-secondary is-medium"
										>{{
											$i18n.locale == "zh-TW"
												? intro.title
												: intro.title_en
										}}</span
									>
								</div>
								<div
									class="ts-text is-center-aligned"
									v-html="
										$i18n.locale == 'zh-TW'
											? intro.introduction
											: intro.introduction_en
									"></div>
							</div>
						</div>
						<div class="column is-2-wide"></div>
					</template>
				</div>
				<div data-name="thanks">
					<div class="ts-container">
						<div class="ts-text">
							{{ $t("about.materialAdopt") }}
							<a
								href="https://pdc.adm.ncu.edu.tw/new/intro_adm.asp"
								>{{ $t("about.pdc") }}</a
							>
							({{ $t("about.mascot") }})、
							<a
								href="https://iconscout.com/contributors/delesign"
								>Delesign Graphics</a
							>
							({{ $t("about.softimg") }})、
							<a href="https://github.com/technext/zinc"
								>technext/zinc</a
							>
							({{ $t("about.template") }})
							{{ $t("about.thankAdopt") }}
						</div>
					</div>
				</div>
			</div>
			<div class="ts-space"></div>
		</section>
	</frontend-layout>
</template>

<script>
import FrontendLayout from "@/Frontend/Shared/Layout";

export default {
	props: {
		status: Number,
	},
	components: {},
	data() {
		return {
			csrf: document
				.querySelector('meta[name="csrf-token"]')
				.getAttribute("content"),
			intros: [
				{
					avaterUrl: "/img/gnsjhenjie.webp",
					name: "謝振杰",
					name_en: "Jhen-Jie Hsieh",
					title: "程式設計",
					title_en: "Developer",
					introduction:
						'啾啾啾! 我是資工系的謝振杰~ 🐤<br />可以在<a href="https://github.com/gnsJhenJie/">GitHub</a>,&nbsp;<a href="https://www.linkedin.com/in/gnsjhenjie">Linkedin</a>找到我',
					introduction_en:
						'Hi! I\'m Eric from department of CSIE~ 🐤<br />You can find me on <a href="https://github.com/gnsJhenJie/">GitHub</a>, or&nbsp;<a href="https://www.linkedin.com/in/gnsjhenjie">Linkedin</a>',
				},
				{
					avaterUrl: "/img/JH.webp",
					name: "黃鉦鈞",
					name_en: "Cheng-Jiun Huang",
					title: "程式設計",
					title_en: "Developer",
					introduction:
						'嗨嗨! 我是108級資管系的黃鉦鈞(つ´ω`)つ<br/>可以在<a href="https://github.com/pocper1/">Github</a>, <a href="https://www.linkedin.com/in/jimmy-cj-huang/">Linkedin</a>找到我',
					introduction_en:
						'Hi! I\'m Jimmy from department of MIS~ <br/>You can find me on <a href="https://github.com/pocper1/">Github</a> or <a href="https://www.linkedin.com/in/jimmy-cj-huang/">Linkedin</a>',
				},
			].sort((a, b) => 0.5 - Math.random()),
		};
	},
	methods: {},
	created: function () {},
	mounted: function () {},
	components: {
		FrontendLayout,
	},
};
</script>
<style scoped>
.card-avater {
	width: 64%;
	margin-left: 18%;
	margin-top: 1.4rem;
}
</style>
